import React from 'react';
import { useLocation } from 'react-router-dom';
import PHRMobileMedicalRecordsItem from '../PHRMobileMedicalRecords/PHRMobileMedicalRecordsItem';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import { Form } from 'antd';
import MedicalRecordsDetailRow from '@/screens/PHRMobile/MedicalRecordsDetail/MedicalRecordsDetailRow';

const MedicalRecordsDetail = () => {
  const location = useLocation();
  const { healthRecord } = location.state;
  const getEmrType = useGlobalMobileConfigs((s) => s.getEmrType);
  const emrType = getEmrType(healthRecord.type.code);
  return (
    <div className="h-full bg-gray-2 flex-col">
      <div className={`p-4 h-[167px]`}>
        <PHRMobileMedicalRecordsItem healthRecord={healthRecord} />
      </div>
      <div className="bg-gray-2 relative h-[calc(100%-167px)] flex-grow">
        <div className="absolute top-0 left-0 bottom-0 right-0 overflow-y-auto px-4">
          <Form initialValues={healthRecord}>
            <MedicalRecordsDetailRow emrType={emrType} fields={emrType?.format?.fields} isFirst disabled />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default MedicalRecordsDetail;
